var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41645 14.3889V19.9444H0.638672V22.7222H4.80534V25.5H7.58312V22.7222H10.3609V25.5H13.1387V22.6514C15.872 22.3056 17.9998 19.9917 17.9998 17.1667C17.9998 15.3333 17.097 13.7167 15.722 12.7042C16.7361 11.6709 17.3046 10.2811 17.3053 8.83333C17.3053 6.25278 15.5289 4.09583 13.1387 3.475V0.5H10.3609V3.27778H7.58312V0.5H4.80534V3.27778H0.638672V6.05556H3.41645V14.3889ZM12.4442 19.9444H6.19423V14.3889H12.4442C13.9762 14.3889 15.222 15.6347 15.222 17.1667C15.222 18.6986 13.9762 19.9444 12.4442 19.9444ZM6.19423 6.05556H11.7498C13.2817 6.05556 14.5276 7.30139 14.5276 8.83333C14.5276 10.3653 13.2817 11.6111 11.7498 11.6111H6.19423V6.05556Z",
    fill: "#00665A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcGreen);
export default __webpack_public_path__ + "static/media/btcGreen.c90781ccd6602a49c38460dc442887ab.svg";
export { ForwardRef as ReactComponent };